import { Dimensions, DIMENSION_TEMPLATE } from "./dimensions";
import { DtacBase } from "./dtac-base";
import { Party } from "./party";
import { Piece } from "./piece";
import { Value, VALUE_TEMPLATE } from "./value";
import { VolumetricWeight, VOLUMETRIC_WEIGHT_TEMPLATE } from "./volumetric-weight";
import { Waybill, WAYBILL_TEMPLATE } from "./waybill";

export interface Shipment extends DtacBase {
  totalGrossWeight: Value;
  volumetricWeight: VolumetricWeight[];
  totalPieceCount: number;
  dimensions: Dimensions[];
  parties: Party[];
  waybillNumber: Waybill;
  containedPieces: Piece[];
};

export const EMPTY_SHIPMENT: Shipment = {
  '@id': '',
  '@type': '',
  totalGrossWeight: VALUE_TEMPLATE,
  volumetricWeight: [VOLUMETRIC_WEIGHT_TEMPLATE],
  totalPieceCount: 0,
  dimensions: [DIMENSION_TEMPLATE],
  parties: [],
  waybillNumber: WAYBILL_TEMPLATE,
  containedPieces: []

};

export interface ShipmentRef extends DtacBase {
};
